export default __webpack_public_path__ + "static/media/image_7.fd95bd82.jpg";